export default __webpack_public_path__ + "static/media/bjarne-stroustrup.720c6985.png";